import { ProductFilter } from './product-filter';

export class ProductFilters {
  constructor(
    public product: ProductFilter[] = [],
    public plan: ProductFilter[] = [],
    public deductible: ProductFilter[] = [],
    public term: ProductFilter[] = [],
    public mileage: ProductFilter[] = []
  ) {}
}
